<template>
  <b-row>
    <b-col cols="auto" align-self="start">
      <b-avatar
        :variant="'light-primary'"
        size="44px"
        :badge-variant="getSexBadgeVariant(occupant.raw)">
        <font-awesome-icon
          :icon="isStudent(occupant) ? getSexIcon(occupant.raw) : 'fas fa-people-roof'"
          style="width: 22px; height: 22px"
        />
        <template v-if="isStudent(occupant)" #badge>
          {{ getSexBadge(occupant.raw) }}
        </template>
      </b-avatar>
    </b-col>

    <b-col align-self="center">
      <div class="text-wrap-balance">
        <router-link :to="{ name: `events-${occupant.type}`, params: { id: occupant.id } }" class="h5 mb-25 font-weight-bolder text-primary ">
          {{ getFullName(occupant, { lnf: true, usePreferred: false }) }}
        </router-link>

        <div v-if="isStudent(occupant) && application" class="font-small-3">
          <span v-if="application && application.selection && application.selection.ensemble">{{ application.selection.ensemble.name }}</span>
          <span v-else class="text-danger">No Ensemble</span>
          -
          <span v-if="application && application.instrument">{{ application.instrument.name }}</span>
          <span v-else class="text-danger">No Instrument</span>
        </div>

        <router-link :to="{ name: 'events-hotel', params: { id: selected.hotel.id } }" class="d-block font-small-3">
          {{ selected.hotel.name }} <span v-if="!hideRoom">- Room {{ room }}</span>
        </router-link>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import events from '@/mixins/event.mixin';

export default {
  name: 'RoomAssignmentOccupant',
  mixins: [ events ],
  props: {
    occupant: {
      type: Object,
      required: true
    },
    selected: {
      type: Object,
      required: true
    },
    hideRoom: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    application() {
      return this.getApplicationWithSelection(this.occupant?.raw?.applications);
    },
    room() {
      return this.isStudent(this.occupant)
        ? this.occupant?.raw?.event?.room
        : this.occupant?.raw?.room;
    }
  },
  methods: {
    isStudent(occupant) {
      return occupant?.type === 'student';
    },
  }
};
</script>

<style scoped>
.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
